import { defineStore } from 'pinia'
import { computed, ref, type Ref } from 'vue'
import type { Field } from './Fields/types'
import { useEntity } from './useEntity'
import type { Entity } from './useProject'

/**
 * A store for managing the entity sidebar state.
 */
export const useEntitySidebarStore = defineStore('entitySidebar', () => {
  const entityStore = useEntity()

  const selectedFileField: Ref<{
    field: Field<'file' | 'file_collection'>
    groundingField?: Field
  } | null> = ref(null)

  const selectedEntityId = computed(() => entityStore.entityId ?? null)
  const selectedEntity = computed<Entity | null>(() => entityStore.entity ?? null)

  const sidebarIsOpen = computed<boolean>(() => !!selectedEntityId.value)

  const setSelectedEntityId = (id: string | null) => {
    entityStore.setEntityId(id ?? undefined)
    selectedFileField.value = null
  }

  const setSelectedFileField = (
    field: Field<'file' | 'file_collection'>,
    groundingField?: Field,
  ) => {
    selectedFileField.value = { field, groundingField }
  }

  const clearSelectedFileField = () => {
    selectedFileField.value = null
  }

  const reset = () => {
    selectedFileField.value = null
    entityStore.setEntityId(undefined)
  }

  return {
    sidebarIsOpen,
    selectedEntityId,
    selectedEntity,
    selectedFileField,
    setSelectedEntityId,
    setSelectedFileField,
    clearSelectedFileField,
    reset,
  }
})
